import { Button } from '@mui/material'
import { HelpCircle } from 'react-feather'
import TextFieldMui from 'src/components/TextFieldMui'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Form = styled.form`
    width: 512px;
    align-self: center;
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: 768px) {
        width: 100%;
        padding: 32px 16px;
    }

    @media (min-width: 769px) and (max-width: 1200px) { width: 70%; }
`

export const FormHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: end;
`

export const FormTitle = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    padding-left: 24px;
`

export const InfoButton = styled(HelpCircle)`
    cursor: pointer;
`

export const FormField = styled(TextFieldMui)`
    margin-top: 0px !important;
`

export const FormFooter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 16px;
`

export const MovementButton = styled(Button)`
    background: ${theme.colors.confirm} !important;

    :disabled {
        background: ${theme.colors.gray} !important;
    }
`

export const ClearButton = styled(Button)`
    background: ${theme.colors.blue} !important;
`
